import { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { save } from './api-observacao-turma';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { addObservacoesTurma, updateObservacoesTurma, setObservacaoTurma as setObservacaoTurmaRedux } from './actions/actions';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import TextFieldDate from '../UI/TextFieldDate';
import dayjs from 'dayjs';

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',

    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    closeIcon: {
        marginTop: '20px',
        cursor: 'pointer'
    },
}));

export default function ObservacaoTurmaForm() {
    const classes = useStyles();
    const observacaoTurmaRedux = useSelector(state => state.observacaoTurma);
    const tdp = useSelector(state => state.tdp);
    const [observacaoTurma, setObservacaoTurma] = useState({
        tdp: tdp
    });
    const dispatch = useDispatch();


    useEffect(() => {
        setObservacaoTurma(observacaoTurmaRedux);
    }, [observacaoTurmaRedux])



    const handleChange = (event) => {
        setObservacaoTurma({
            ...observacaoTurma,
            [event.target.name]: event.target.value
        })
    }

    const handleDataChange = (data) => {

        setObservacaoTurma({
            ...observacaoTurma,
            data: dayjs(data)
        })
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        const codObservacaoTurma = observacaoTurma.codigo;
        save(observacaoTurma).then(data => {
            if (data) {
                toast.success("Salvo com sucesso.", {
                    position: "bottom-left"
                });
                if (codObservacaoTurma) {
                    dispatch(updateObservacoesTurma(data));
                } else {
                    dispatch(addObservacoesTurma(data));
                }
                setObservacaoTurma(data);
            }
        });
    }


    return (
        <div>
            <Grid container spacing={3}>
                <Grid size={12}>
                    <Container className={classes.paper} component={Paper} maxWidth="sm">
                        <CloseIcon
                            onClick={() => dispatch(setObservacaoTurmaRedux(null))}
                            className={classes.closeIcon}
                            fontSize='small'
                        />
                        <form onSubmit={clickSubmit}>
                            <TextFieldDate
                                fullWidth
                                required
                                margin="normal"
                                label="Data"
                                value={observacaoTurma && observacaoTurma.data ? observacaoTurma.data : null}
                                onChange={handleDataChange}

                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                multiline
                                rows="4"
                                fullWidth
                                label="Conteúdo"
                                name="conteudo"
                                onChange={handleChange}
                                value={observacaoTurma && observacaoTurma.conteudo ? observacaoTurma.conteudo : ''}
                                slotProps={{
                                    htmlInput: { maxLength: 255 }
                                }}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Salvar
                            </Button>
                        </form>
                    </Container>
                </Grid>
            </Grid>
        </div>
    );
}